"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calulateMarketShiftTable = exports.calculateMarketShiftTables = exports.getMarketShiftTableInfo = exports.extendWithDvolVolatility = exports.getCurrencyPnlMap = void 0;
const calculationsCore_1 = require("../calculationsCore");
const pnlCalculations_1 = require("../pnlCalculations");
const priceMovesCalculationsFunctions_1 = require("../pnlCalculations/priceMovesCalculationsFunctions");
const types_1 = require("./types");
const utils_1 = require("./utils");
const getCurrencyPnlMap = (marketShiftTable, positionsUuidMap, pmParams, dvolTable) => {
    let currencyPnl = {};
    const entries = Object.entries(marketShiftTable);
    let minShiftTable = Number.MAX_SAFE_INTEGER;
    let maxShiftTable = Number.MIN_SAFE_INTEGER;
    const length = entries.length === 0 ? 0 : entries[0][1].length;
    for (const [uuid, moves] of entries) {
        const positionCurrency = (0, calculationsCore_1.getBaseCurrencyFromInstrumentString)(positionsUuidMap[uuid]);
        minShiftTable = Math.min(minShiftTable, ...moves.flat());
        maxShiftTable = Math.max(maxShiftTable, ...moves.flat());
        currencyPnl[positionCurrency] = currencyPnl[positionCurrency]
            ? (0, utils_1.sumMoveRows)(currencyPnl[positionCurrency], moves)
            : moves;
    }
    currencyPnl = (0, exports.extendWithDvolVolatility)(currencyPnl, dvolTable, length);
    const marginRequirements = (0, utils_1.sumCurrencyPnlWithFactor)(currencyPnl, pmParams);
    const totalSumMin = Math.min(...marginRequirements.flat());
    return {
        currencyPnl,
        marginRequirements,
        minShiftTable,
        maxShiftTable,
        totalSumMin,
    };
};
exports.getCurrencyPnlMap = getCurrencyPnlMap;
const extendWithDvolVolatility = (currencyPnl, dvolTable, emptyRowLength) => {
    const res = dvolTable.reduce((memo, current) => {
        const volCurrency = (0, pnlCalculations_1.getVolUnerlyingCurrencyFromInstrumentString)(current.instrument);
        const currentCurrencyMoves = !memo[volCurrency]
            ? (0, utils_1.expandMovesWithVolatility)((0, utils_1.getEmptyMovesRow)(emptyRowLength), current.down, current.up)
            : (0, utils_1.expandMovesWithVolatility)(memo[volCurrency], current.down, current.up);
        return Object.assign(Object.assign({}, memo), { [volCurrency]: currentCurrencyMoves });
    }, Object.assign({}, currencyPnl));
    return res;
};
exports.extendWithDvolVolatility = extendWithDvolVolatility;
const getPmMarginTable = (corePositions, normalMarketShiftTable, extendedMarketShiftTable) => {
    return corePositions.map((position) => {
        return {
            position,
            normalMoves: normalMarketShiftTable[position.uuid],
            extendedMoves: extendedMarketShiftTable[position.uuid],
        };
    });
};
const getMarketShiftTableInfo = (marketShiftTable, positionsUuidMap, pmParams, dvolTable) => {
    const { currencyPnl, marginRequirements, maxShiftTable, minShiftTable, totalSumMin, } = (0, exports.getCurrencyPnlMap)(marketShiftTable, positionsUuidMap, pmParams, dvolTable);
    const factoredInfo = (0, utils_1.minMarketShiftRow)(marginRequirements);
    const min = Math.min(...marginRequirements.flat());
    return {
        currencyPnl,
        marginRequirements,
        factoredInfo,
        min,
        maxShiftTable,
        minShiftTable,
        totalSumMin,
    };
};
exports.getMarketShiftTableInfo = getMarketShiftTableInfo;
const calculateMarketShiftTables = (positions, positionsUuidMap, tickers, pmParams, dvolTable, calculationTimestamp) => {
    const marketShiftTableNormal = (0, exports.calulateMarketShiftTable)(positions, tickers, pmParams, types_1.MarketShiftType.Normal, calculationTimestamp);
    const marketShiftTableExtended = (0, exports.calulateMarketShiftTable)(positions, tickers, pmParams, types_1.MarketShiftType.Extended, calculationTimestamp);
    const marketShiftInfo = (0, exports.getMarketShiftTableInfo)(marketShiftTableNormal, positionsUuidMap, pmParams, dvolTable);
    const marginTableRows = getPmMarginTable(positions, marketShiftTableNormal, marketShiftTableExtended);
    return {
        marginTableRows,
        marketShiftInfo,
        marketShiftTableExtended,
        marketShiftTableNormal,
    };
};
exports.calculateMarketShiftTables = calculateMarketShiftTables;
const calulateMarketShiftTable = (positions, tickers, pmParams, marketShiftType, calculationTimestamp) => {
    const priceMovesPerPosition = {};
    for (const position of positions) {
        const underlyingCurrency = (0, calculationsCore_1.getBaseCurrencyFromInstrumentString)(position.instrument);
        const currParams = pmParams.currencyParams[underlyingCurrency];
        const movesPnl = priceMovesCalculationsFunctions_1.movesFunctions[(0, calculationsCore_1.getInstrumentType)(position.instrument)](position, tickers[position.instrument], pmParams, marketShiftType === types_1.MarketShiftType.Normal
            ? currParams.moves
            : currParams.extendedMoves, calculationTimestamp);
        priceMovesPerPosition[position.uuid] = movesPnl;
    }
    return priceMovesPerPosition;
};
exports.calulateMarketShiftTable = calulateMarketShiftTable;
